import {Tile, TILE_TYPE_SIMPLE_ANALOG, TILE_TYPE_SIMPLE_BOOL, TILE_TYPE_SIMPLE_MULTISTATE} from './tile';
import {SimpleAnalogStructure, SimpleBoolStructure, SimpleMultistateStructure} from './structure';

export type TileValueType = string | number | boolean | null;

export class TileValueParser {
  public tile: Tile;
  public rawValue: TileValueType;

  constructor(tile: Tile, raw?: TileValueType) {
    this.tile = tile;
    this.rawValue = raw;
  }

  /**
   * Returns the current, live value for a tile that a component will further
   * polish/style and eventually render to the end user.
   *
   * The main purpose of this getter is to calculate current value in situations
   * where the raw value is *too* raw and potentially needs additional processing
   * to be determined. Example 1: multistate value string, which requires knowing
   * the raw value and the mapping of multistate value strings. Example 2: analog
   * value statuses that are shown as "On"/"Off" after evaluating a comparison
   * function.
   */
  getDisplayValue(rawValue?): string {
    if (typeof rawValue === 'undefined') {
      rawValue = this.rawValue;
    }

    let s;

    switch (this.tile.Type) {
      case TILE_TYPE_SIMPLE_BOOL:
        s = (this.tile.Structure as SimpleBoolStructure);

        if (rawValue === true) {
          return s.DisplayTrue;
        }

        return s.DisplayFalse;

      case TILE_TYPE_SIMPLE_ANALOG:
        s = (this.tile.Structure as SimpleAnalogStructure);
        const numeric = +rawValue;

        if (rawValue != numeric) {
          return '0';
        }

        let decimals = 2;

        if (this.tile.Appearance.Config && typeof this.tile.Appearance.Config.Decimal !== 'undefined') {
          decimals = this.tile.Appearance.Config.Decimal;
        }

        return String(numeric.toLocaleString(undefined, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }));

      case TILE_TYPE_SIMPLE_MULTISTATE:
        s = (this.tile.Structure as SimpleMultistateStructure);

        let match = s.DisplayStates.find((ds) => {
          return ds.CompareFunc.Value === rawValue;
        });

        if (match) {
          return match.DisplayText;
        } else {
          return rawValue + ' ?';
        }
    }
  }
}
